module.exports = __webpack_public_path__ + "static/java-74e943d82452f81f6a0bb0b51ac6785d.png";